import { defineStore } from 'pinia'
import { ref } from 'vue'
import { HttpClient } from '@/http/httpClient'
import { useDailyFrequency } from '@zaohaowu/website-common/hooks/useDailyFrequency'
import { useUserStore } from '@zaohaowu/website-common/stores/userStore'
import { useRoute } from 'vue-router'
import { modifyUrl } from '@/utils/modifyUrl'
import { eventBus } from '@zaohaowu/website-common/utils/eventBus'
const http = new HttpClient()

interface ICheckSystemPopupLevelOptions {
  shouldShowSplash?: (isHigherPriority?: boolean) => boolean
  needSplash?: boolean
  incentiveDialogUrl?: string
  splashShowCallback?: (msgId: string, isHigherPriority?: boolean) => {}
}

export const useDialogStore = defineStore('dialog', () => {
  const userStore = useUserStore()
  const route = useRoute()
  const isSplashVisible = ref(false)
  const isGuideVisible = ref(false)
  const isIncentiveDialogVisible = ref(false)
  const isDownloadAppDialogVisible = ref(false)
  const incentiveDialogData = ref<Record<string, any> | null>(null)
  const splashData = ref<{
    payloadJson: {
      title: string
      content: string
      button_text: string
      landing_url: string
      p0_popup_closable?: number
      p0_popup_priority?: number
      web_popup_image: string
    }
    msgId: string
  } | null>(null)
  const downloadAppDialogFooterText = ref<string>('')
  const { isEarlyThanToday, setDailyFrequency } = useDailyFrequency()

  const shouldFetchIncentive = () => {
    const time = localStorage.getItem('incentive_api')
    return userStore.isLogin && isEarlyThanToday(time)
  }

  const closeIncentiveDialog = () => {
    incentiveDialogData.value = null
    isIncentiveDialogVisible.value = false
  }

  const openDownloadAppDialog = (payload?: { footerText?: string }) => {
    isDownloadAppDialogVisible.value = true
    downloadAppDialogFooterText.value = payload?.footerText || ''
  }

  const closeDownloadAppDialog = () => {
    isDownloadAppDialogVisible.value = false
    downloadAppDialogFooterText.value = ''
  }

  eventBus.addEvent('openDownloadAppDialog', (payload?: { footerText?: string }) => {
    openDownloadAppDialog(payload)
  })

  const closeSplash = () => {
    splashData.value = null
    isSplashVisible.value = false
  }

  const readSplash = async (msgId: string, isHigherPriority?: boolean) => {
    if (userStore.isLogin) {
      setDailyFrequency('splashScreen')
      if (isHigherPriority) {
        setDailyFrequency('high_priority_splash_screen')
      }
      await http.put(
        modifyUrl('/aigc/api/message/read', {
          msgIdList: msgId
        })
      )
    }
  }
  const checkSystemPopupLevel = (options: ICheckSystemPopupLevelOptions, splashList: any[]) => {
    if (splashList?.length > 0) {
      const splashItem = splashList[0]
      if (options?.shouldShowSplash?.(splashItem.payloadJson.p0_popup_priority !== undefined)) {
        splashData.value = splashItem
        // 当为手动点击 登录领礼品 复层时，因为已经展示想要的抽屉，对应的首次p0弹窗、以及高亮引导则不再展示
        eventBus.addEvent('isSplashVisible', () => {
          console.log('isSplashVisible')
          isSplashVisible.value = false
          readSplash(splashItem.msgId, splashItem.payloadJson.p0_popup_priority !== undefined)
          eventBus.removeEvent('isSplashVisible')
          return
        })

        const newTicketShadow = localStorage.getItem('newTicketShadow')
        console.log('newTicketShadow', newTicketShadow)
        if (newTicketShadow === 'true') {
          isSplashVisible.value = true
        } else {
          // 当 newTicketShadow 为 false 时，监听遮罩关闭事件
          eventBus.addEvent('newTicketShadowClosed', () => {
            console.log('newTicketShadowClosed')
            isSplashVisible.value = true
            eventBus.removeEvent('newTicketShadowClosed')
          })
        }

        if (splashItem.payloadJson.p0_popup_closable !== 0) {
          readSplash(splashItem.msgId, splashItem.payloadJson.p0_popup_priority !== undefined)
        }
        return
      }
    }
  }

  const fetchDialogData = async (options?: ICheckSystemPopupLevelOptions) => {
    const resultList = await Promise.allSettled([
      options?.incentiveDialogUrl && shouldFetchIncentive()
        ? http.get<any>(options?.incentiveDialogUrl, {
            type: 'ACTIVE'
          })
        : Promise.reject('empty promise'),
      options?.needSplash
        ? http.get('/aigc/api/message/system/popUp')
        : Promise.reject('empty promise')
    ])
    if (resultList[1].status === 'fulfilled') {
      const splashList =
        resultList[1].value?.data?.dataList?.filter(
          (item: any) => item?.payloadJson?.overActivityPopup
        ) || []
      if (splashList?.length) {
        try {
          checkSystemPopupLevel(options as ICheckSystemPopupLevelOptions, splashList)
          return
        } catch (error) {
          console.log(error)
        }
      }
    }
    if (resultList[0].status === 'fulfilled' && resultList[0].value.data) {
      incentiveDialogData.value = resultList[0].value.data
      isIncentiveDialogVisible.value = true
      setDailyFrequency('incentive_api')
      return
    }
    if (resultList[1].status === 'fulfilled') {
      const splashList = resultList[1].value?.data?.dataList
      try {
        checkSystemPopupLevel(options as ICheckSystemPopupLevelOptions, splashList)
      } catch (error) {
        console.log(error)
      }
    }
    isGuideVisible.value = !route.query.openWantLayer
  }
  return {
    isSplashVisible,
    isGuideVisible,
    isIncentiveDialogVisible,
    isDownloadAppDialogVisible,
    incentiveDialogData,
    splashData,
    downloadAppDialogFooterText,
    fetchDialogData,
    closeIncentiveDialog,
    openDownloadAppDialog,
    closeDownloadAppDialog,
    closeSplash,
    readSplash
  }
})
